module.exports = __webpack_public_path__ + "img/service-zhinengfanqizha3.ec982cfc.svg";